import React from "react";
import { ClaimsByAuthorJudgeInstitutionOutcomeChart, ClaimsByAuthorJudgeFWDOutcomeChart, ClaimsByPanelJudgeInstitutionOutcomeChart, ClaimsByPanelJudgeFWDOutcomeChart } from "./charts";
import { Divider } from "antd";
import UserAccess from "../../../common/user-access";
import { keepOnlyPTABQueryStrings } from "../../../../helpers/url";

const ClaimTabJudge = props => {
  const q = keepOnlyPTABQueryStrings(props.location.query);
  return (
    <UserAccess showHelp={true}>
      <ClaimsByAuthorJudgeInstitutionOutcomeChart query={q} />
      <Divider />
      <ClaimsByAuthorJudgeFWDOutcomeChart query={q} />
      <Divider />
      <ClaimsByPanelJudgeInstitutionOutcomeChart query={q} />
      <Divider />
      <ClaimsByPanelJudgeFWDOutcomeChart query={q} />
    </UserAccess>
  );
};

export default ClaimTabJudge;
